module.exports = __webpack_public_path__ + "static/media/decathlon.70c34dd4.webp";